import {
    Directive,
    EventEmitter,
    HostListener,
    Input,
    Output
  } from '@angular/core';
  import { GridApi, IDatasource, IGetRowsParams } from 'ag-grid-community';
  import { EMPTY, Observable } from 'rxjs';
  import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from './notification.service';

export interface RemoteGridApi {
    getData: (params: IGetRowsParams) => Observable<{ data; totalRecords }>;
    getDataError?: (err) => void;
    gridApi: GridApi;
  }

   
  @Directive({
    selector: '[remoteGridBinding]',
    standalone: false // NOSONAR
})
  export class RemoteGridBindingDirective {
    @Input()
    remoteGridBinding: RemoteGridApi;
    @Input() pageSize: number = 10;
    @Output()
    remoteGridReady = new EventEmitter();
  
    constructor(
        public notificationService: NotificationService
    ) {}
  
    @HostListener('gridReady', ['$event']) gridReady(gridApi: GridApi) {
      this.updateGridApi(gridApi);
    }
  
    updateGridApi(gridApi) {
      gridApi.api.setDatasource(this.dataSource);
      this.remoteGridReady.emit(gridApi);
    }
  
    handleError(err) {
      this.remoteGridBinding.getDataError(err);
      return EMPTY;
    }
  
    dataSource: any = {
      getRows: (params: any) => {

        this.notificationService
          .getNotifications({...params, pageSize: this.pageSize})
          .pipe(
            tap((data): any =>
              params.successCallback(data?.tnotificationsDTOS, data?.navOptions?.totalRecords)
            ),
            catchError(err => this.handleError(err))
          )
          .subscribe();
      }
    };
  }